import { useEffect, useState } from "react";

const Ecash = () =>{

    return(<> 
    
   
  
    {/* <!-- Breadcumb Section Start --> */}
    <div className="breadcrumb-img">
     <img src="assets/img/banner/ecash.jpg" alt="MeriPustak-ecash"/>
       
    </div>

    {/* <!-- About Section Start --> */}
    <section className="about-section fix section-padding">
        <div className="container">
            <div className="about-wrapper">
			
                
			
				<div className="row g-4 align-items-center col-con">
                    <div className="col-lg-4 values">
                        <div className="about-content value">
							 <img src="assets/img/icon/cash.jpg" alt="MeriPustak-Earn eCash"/>
                           <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Earn eCash Back On every Online Order</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                            <b>Pay Online</b> and earn eCash on each and every Order made at MeriPustak.com</p>
                        </div>
                    </div>
					<div className="col-lg-4 values">
                        <div className="about-content value">
							<img src="assets/img/icon/quick.jpg" alt="MeriPustak-Quick & Easy Usage"/>
                           <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Quick & Easy Usage</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                             Use your eCash without hassles, Just apply the amount of eCash available with you on your Order and see instant deduction from the total Order amount.</p>
                        </div>
                    </div>
					<div className="col-lg-4 values">
                        <div className="about-content value">
							<img src="assets/img/icon/safe.jpg" alt="MeriPustak-Safe & Secure"/>
                           <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Safe & Secure</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                             Your MeriPustak eCash is 100% encrypted and can only be used after login in your MeriPustak credentials</p>
                        </div>
                    </div>
                </div>
				
				<div className="row g-4 align-items-center text-center">
                    <div className="col-lg-12">
                        <div className="about-content">
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                              <span className="sm-sz"><b>Note :-</b> eCash is only applicable for customers who have registered on MeriPustak. To avail the benefits of eCash <a data-bs-toggle="modal" data-bs-target="#loginModal" target="_blank">Register Now</a></span></p>
                        </div>
                    </div>
                </div>
				
				
				
            </div>
        </div>
    </section>

     

    </>);

}

export default Ecash;